
//import $ from 'jquery'
import {UserOutlined, LaptopOutlined, NotificationOutlined} from '@ant-design/icons-vue';
import {defineComponent, ref} from 'vue';
// import WelCome from './components/WelCome.vue'


export default defineComponent({
  name: 'App',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    UserOutlined,
    // eslint-disable-next-line vue/no-unused-components
    LaptopOutlined,
    // eslint-disable-next-line vue/no-unused-components
    NotificationOutlined,

  },
  setup() {
    return {
      selectedKey: '',
      selectedKeys1: ref<string[]>(['1']),
      selectedKeys2: ref<string[]>(['2']),
      collapsed: ref<boolean>(false),
      openKeys: ref<string[]>(['sub1']),
    };
  },
  props: {
    msg: String
  },
  data() {
    return {
      imgdata: '',
      showcontent: false,
    }
  },
  methods: {


    changeDownLoad() {
      this.selectedKey = 5;
      this.$router.push({
        path: 'DownLoad',
      })
    },
    changeBrowsePage() {
      this.selectedKey = 2;
      this.$router.push({
        path: 'BrowsePage',
      })
    },
    showWelcome() {
      this.selectedKey = 1;

      this.$router.push({
        path: 'WelCome',
      })
    },


    changeQueryPage() {
      this.selectedKey = 3;
      this.$router.push({
        path: 'QueryPage',
      })
    },
    changeHelpPage() {
      this.selectedKey = 4;
      this.$router.push({
        path: 'HelpPage',
      })
    },
    changeFeedBack() {
  this.selectedKey = 6;
  this.$router.push({
    path: 'FeedBack',
  })
  },




  },
  mounted() {
    const path = this.$route.path;
    if (path === '/WelCome') {
      this.selectedKey = '1';
    } else if (path === '/BrowsePage') {
      this.selectedKey = '2';
    } else if (path === '/UpLoad') {
      this.selectedKey = '3';
    } else if (path === '/DPBMC') {
      this.selectedKey = '4';
    } else if (path === '/DSource') {
      this.selectedKey = '5';
    } else if (path === '/LoginPage') {
      this.selectedKey = '6';
    }


  }
});
